/* eslint-disable no-console */

import React, { useState, useContext, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Switch, useMediaQuery } from '@material-ui/core';

import LoaderButton from './LoaderButton';

import ProtocolDialog from './ProtocolDialog';

import RebootButton from './Setup/RebootButton';
import SelectSearch from './SelectSearch';
import DeviceContext from '../context/DeviceContext';
import BerichteButton from './Setup/BerichteButton';
import EmiconContext from '../../emicon/context/EmiconContext';
import CsvButton from './CsvButton';
import ProtocolDialogEmicon from '../../emicon/components/Support/ProtocolDialogEmicon';
import { Device, Emicon } from '../../../types/Device';
import handleAnlagenStatusNew from '../../utils/handleAnlagenstatus';
import convertDate from '../../utils/convertDate';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiFilledInput-input': {
      padding: '6px 20px 6px 8px',
    },
    '.MuiCardHeader-action': {
      margin: 0,
    },
  },
  header: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: 6,
    },
    marginBottom: theme.spacing(1),
  },
  selectWrapper: {
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
  },
  loader: {
    position: 'absolute',
    left: 302,
    top: 7,
    [theme.breakpoints.down('xs')]: {
      margin: '8px 10px',
      top: -2,
      left: 175,
    },
  },

  buttonWrapper: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      marginTop: -2,
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: -2,
    },
  },

  controlWrapper: {
    display: 'flex',
    marginTop: theme.spacing(1),
    justifyContent: 'space-between',
  },

  buttonInGrid: {
    // padding: '0px 16opx', //TODO? What the fuck is this?
    padding: '0px 16px',
  },

  shadowInputButton: {
    fontSize: '16px',
    margin: '2px',
    height: '40px',
    '&.Mui-disabled': {
      color: 'black',
    },
    '&.MuiOutlinedInput-input': {
      padding: '0px !important',
    },
  },

  shadowInputDarkButton: {
    background: '#014a69',
    color: 'white !important'
  },

  chipColor: {
    background: '#38b6f1',
    color: 'black',
  },

  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

}));

interface SetupHeaderProps {
  hideButtons?: boolean
  children?: React.ReactElement[] | null
  showBetreiber?: boolean
  isEmicon?: boolean
  hasBearbeitung?: boolean
  isMotorlast?: boolean
  setIsMotorlast?: Function
}

export default function SetupHeader({
  hideButtons = false, children = null, showBetreiber = false, isEmicon = false, hasBearbeitung = false, isMotorlast, setIsMotorlast = () => { },
}: SetupHeaderProps) {

  const {
    currentDevice, loading, setCurrentDevice, fetchDevices
    // @ts-ignore
  } = useContext(isEmicon ? EmiconContext : DeviceContext);

  async function submitAnlagenstatus(status: string) {
    await handleAnlagenStatusNew(currentDevice, isEmicon, status);

    setOpen(false);

    if (isEmicon) {
      setCurrentDevice((prevState: Emicon) => ({ // Direkt auf aktueller Seite updaten
        ...prevState,
        AnlagenStatus: status,
      }));
      fetchDevices(); // Neuen State aus db laden
    } else {
      setCurrentDevice((prevState: Device) => ({ // Direkt auf aktueller Seite updaten
        ...prevState,
        AnlagenStatus: status,
      }));
      fetchDevices(); // Neuen State aus db laden
    }
  }

  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const mobile = useMediaQuery('(max-width:600px)');

  const [protocolOpen, setProtocolOpen] = useState(false);
  const [protocolOpenEmicon, setProtocolOpenEmicon] = useState(false);


  function openProtocolDialog(isEmicon: boolean) {
    if (isEmicon) {
      setProtocolOpenEmicon(true)
    } else {
      setProtocolOpen(true)
    }
  }

  const renderProtocolButton = () => (
    <div className={classes.buttonWrapper}>
      <LoaderButton
        isLoading={false} // Öffnet nur Dialog
        text="↓ Protokoll"
        disabled={typeof currentDevice?.serialNumber === 'undefined' || loading}
        onClick={() => openProtocolDialog(isEmicon)}
        noMargin
        fullWidth
      />
    </div>
  );

  // useEffect(() => {
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentDevice.serialNumber]);

  const handleBearbeitungClose = (_event: any, reason: string) => {
    // if (reason === 'backdropClick') {
    //   return;
    // }
    setOpen(false)
  };

  const renderHeader = () => (

    <Grid container spacing={2} justifyContent={mobile ? 'space-between' : 'flex-start'} alignItems="center">
      <Grid item xs="auto" sm="auto" md="auto" lg="auto">
        <Typography variant="h5" display="inline">
          EMI-
          {isEmicon ? 'CON' : 'LOG'}
        </Typography>
      </Grid>
      <Grid item xs={12} sm="auto" md="auto" lg="auto">
        <SelectSearch loading={loading} isEmicon={isEmicon} />
      </Grid>
      {showBetreiber ? (
        <Grid item>
          <Typography variant="h6" display="inline">
            {currentDevice.Betreiber}
          </Typography>
        </Grid>
      ) : (
        null
      )}
      {!hideButtons ? (
        <>
          <Grid item className={classes.buttonInGrid} xs={6} sm={6} md="auto" lg="auto">
            <CsvButton serialNumber={currentDevice?.serialNumber} isEmicon={isEmicon} />
          </Grid>
          <Grid item className={classes.buttonInGrid} xs={6} sm={6} md="auto" lg="auto">
            <BerichteButton serialNumber={currentDevice?.serialNumber} isEmicon={isEmicon} />
          </Grid>

          {isEmicon ? (
            <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
              {renderProtocolButton()}
            </Grid>
          ) : (
            <>
              <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
                {renderProtocolButton()}
              </Grid>
              <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
                <RebootButton serialNumber={currentDevice ? currentDevice.serialNumber : ''} active={typeof currentDevice?.serialNumber !== 'undefined'} />
              </Grid>

            </>
          )}

          {/* Bearbeitungstatus Buttons*/}

          {hasBearbeitung ? (
            <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
              <div className={classes.buttonWrapper}>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  disabled={!currentDevice?.serialNumber}
                  onClick={() => setOpen(true)}
                >
                  Bearbeitungsstatus
                </Button>
                <Dialog open={open} onClose={handleBearbeitungClose}>
                  <DialogTitle>
                    Bearbeitungsstatus wählen
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Wählen Sie einen Bearbeitungsstatus aus. Der Bearbeitungsstatus ist für 14 Tage gültig. Sollte der Status innerhalb dieser Zeit
                      Aktualisiert werden, wird auch der Gültigkeitszeitraum erneuert.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      variant="contained"
                      color="primary"
                      component="label"
                      disabled={!currentDevice?.serialNumber}
                      onClick={() => submitAnlagenstatus('Bearbeitung')}
                    >
                      Bearbeitung
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      component="label"
                      disabled={!currentDevice?.serialNumber}
                      onClick={() => submitAnlagenstatus('Angebot')}
                    >
                      Angebot
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      component="label"
                      disabled={!currentDevice?.serialNumber}
                      onClick={() => submitAnlagenstatus('Abgeschlossen')}
                    >
                      Abschließen
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Grid>
          ) : (
            null
          )}

          {/* Bearbeitungsanzeige */}

          {currentDevice && currentDevice.AnlagenStatus && currentDevice.AnlagenStatus !== 'Abgeschlossen' ? (
            <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
              <Chip
                className={classes.chipColor}
                label={`STATUS: ${currentDevice?.AnlagenStatus?.toUpperCase()} ${currentDevice?.AnlagenStatusEnde && currentDevice.AnlagenStatusEnde > 0 ? ` (bis zum ${convertDate(currentDevice.AnlagenStatusEnde)})` : ''}`}
              />
            </Grid>
          ) : null}

          {!isEmicon ? (
            <Grid item className={classes.buttonInGrid} xs={12} sm={6} md="auto" lg="auto">
              <Box className={classes.switchWrapper}>
                {/* <Switch
                  color="primary"
                  checked={isMotorlast}
                  onChange={() => setIsMotorlast((prevValue: boolean) => !prevValue)} // Pass a function reference
                />
                <Chip
                  label={isMotorlast ? 'Motorlastsignal wird genutzt' : 'Motorlastsignal wird nicht genutzt'}
                /> */}
                <Chip
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: 8 }}>
                        MOTORLASTSIGNAL
                      </span>
                      <Switch
                        color="primary"
                        checked={isMotorlast}
                        onChange={() => setIsMotorlast((prevValue: boolean) => !prevValue)} // Pass a function reference
                      />
                    </div>
                  }
                />
              </Box>
            </Grid>
          ) : (
            null
          )}

        </>
      ) : (
        children
      )}
    </Grid>
  );

  return (

    <div className={classes.header}>
      {renderHeader()}
      <ProtocolDialog
        serialNumber={currentDevice?.serialNumber}
        open={protocolOpen}
        onClose={() => setProtocolOpen(false)}
      />
      <ProtocolDialogEmicon
        isEmicon
        serialNumber={currentDevice?.serialNumber}
        open={protocolOpenEmicon}
        onClose={() => setProtocolOpenEmicon(false)}
      />
    </div>

  );
}
